import useGetExaminationResultsByExamCardId, {
  QmsFoMyExamPapersQueryType,
  QmsExamPaperStatus,
  QmsOrderType,
} from './useGetExaminationResultsByExamId';

export default useGetExaminationResultsByExamCardId;
export { QmsExamPaperStatus, QmsOrderType };
export type { QmsFoMyExamPapersQueryType };
